/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2015, 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { ContentStoreObject } from '@businessanalytics/content-nav';

class PackageAction {
	constructor() {
	}

	isDefaultActionView = (payLoad) => {
		const defaultAction = payLoad[ContentStoreObject.DEFAULT_PORTAL_ACTION];
		if (defaultAction && defaultAction ==='view') {
			return true;
		}
		return false;
	}

	canExecute = (payLoad) => {
		return ContentStoreObject.hasPermissions(payLoad, ['traverse']);
	}
}

export default new PackageAction();